import { ChangeDetectionStrategy, Component, input, output } from '@angular/core';
import { MatRippleModule, ThemePalette } from '@angular/material/core';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatTooltipModule } from '@angular/material/tooltip';

import { BaseLoadingButton } from '../shared/base-button';

@Component({
  selector: 'hypecast-admin-buttons-submit',
  templateUrl: './buttons-submit.component.html',
  styleUrl: './buttons-submit.component.scss',
  standalone: true,
  imports: [MatProgressSpinnerModule, MatRippleModule, MatTooltipModule],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ButtonsSubmitComponent extends BaseLoadingButton {
  override readonly clicked = output<void>();

  readonly tooltipText = input<string>();
  readonly submitButtonText = input<string>();
  readonly tooltipDisabled = input<boolean>();
  readonly spinnerColor = input<ThemePalette>('primary');
  readonly spinnerCssColor = input<string>();
}
